// Create a namespace for our quiz service
(function() {
  window.quizService = window.quizService || {};
  
  // UPDATED: Supabase configuration instead of Glitch
  const PROXY_URL = 'https://ejhsttpvnyqmeziyrvjn.supabase.co/functions/v1';
  const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVqaHN0dHB2bnlxbWV6aXlydmpuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIwNzU2OTUsImV4cCI6MjA2NzY1MTY5NX0.NjopauGkpEbnJNw8GEVG-t8zCzBHrUyNGg-bmpNwhEA';
  
  window.quizService.PROXY_URL = PROXY_URL;
  window.quizService.SUPABASE_ANON_KEY = SUPABASE_ANON_KEY;
  
  // Initialize status tracking
  let serviceInitialized = false;
  
  // Attempt to initialize the service
  function initService() {
    try {
      console.log('Initializing Supabase quiz service...');
      // Simple initialization - Supabase functions are always available
      serviceInitialized = true;
      console.log('Supabase quiz service initialized successfully');
      
      // Dispatch ready event
      const readyEvent = new CustomEvent('quizServiceReady');
      window.dispatchEvent(readyEvent);
    } catch (error) {
      console.error('Error initializing quiz service:', error);
      const errorEvent = new CustomEvent('quizServiceError', { detail: error });
      window.dispatchEvent(errorEvent);
    }
  }
  
  // Initialize immediately
  initService();
  
  // Helper function to check initialization
  const ensureInitialized = () => {
    if (!serviceInitialized) {
      return Promise.reject(new Error('Quiz service not initialized.'));
    }
    return Promise.resolve();
  };
  
  // UPDATED: Save quiz completion using Supabase
  window.quizService.saveQuizCompletion = async function(quizData) {
    try {
      // Wait for initialization
      await ensureInitialized();
      
      // Add timestamp and metadata
      const dataToSave = {
        ...quizData,
        timestamp: new Date().toISOString(),
        platform: navigator.userAgent,
        source: document.referrer || 'direct',
        shopDomain: window.location.hostname
      };
      
      console.log('Sending quiz data to Supabase...');
      
      // UPDATED: Send to Supabase Edge Function
      const response = await fetch(`${PROXY_URL}/save-quiz-data-function`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
          'X-Shop-Domain': window.location.hostname
        },
        body: JSON.stringify(dataToSave) // Direct data, no wrapper needed for Supabase
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(
          errorData?.message || `Supabase error: ${response.status} ${response.statusText}`
        );
      }
      
      const result = await response.json();
      console.log("Quiz data saved via Supabase with ID:", result.id);
      
      // Also store in localStorage as backup
      try {
        const existingData = localStorage.getItem('quizCompletionTracking') || '[]';
        const trackingArray = JSON.parse(existingData);
        trackingArray.push({
          ...dataToSave,
          firestoreId: result.id,
          savedAt: new Date().toISOString()
        });
        localStorage.setItem('quizCompletionTracking', JSON.stringify(trackingArray));
      } catch (storageError) {
        console.warn('Failed to save backup to localStorage:', storageError);
      }
      
      return result;
    } catch (error) {
      console.error("Error saving quiz data:", error);
      
      // Fallback to local storage
      try {
        const existingData = localStorage.getItem('quizCompletionTracking') || '[]';
        const trackingArray = JSON.parse(existingData);
        trackingArray.push({
          ...quizData,
          timestamp: new Date().toISOString(),
          error: error.message
        });
        localStorage.setItem('quizCompletionTracking', JSON.stringify(trackingArray));
        
        return {
          success: false,
          stored: 'localStorage',
          error: error.message,
          message: 'Saved to localStorage as fallback'
        };
      } catch (storageError) {
        return Promise.reject(error);
      }
    }
  };
  
  // UPDATED: Get recent quiz completions (you can implement this in Supabase if needed)
  window.quizService.getRecentQuizCompletions = async function(limitCount = 50) {
    try {
      console.log('Recent completions not implemented in Supabase yet, using localStorage fallback');
      
      // Fallback to localStorage
      const trackingData = localStorage.getItem('quizCompletionTracking') || '[]';
      return JSON.parse(trackingData).slice(0, limitCount);
    } catch (error) {
      console.error("Error fetching quiz completions:", error);
      return [];
    }
  };
  
  // UPDATED: Get analytics summary (you can implement this in Supabase if needed)
  window.quizService.getAnalyticsSummary = async function() {
    try {
      console.log('Analytics summary not implemented in Supabase yet, using localStorage fallback');
      
      // Fallback to localStorage
      try {
        const trackingData = localStorage.getItem('quizCompletionTracking') || '[]';
        const parsedData = JSON.parse(trackingData);
        
        // Basic analytics from localStorage
        const analytics = {
          source: 'localStorage',
          totalCompletions: parsedData.length,
          skinTypes: {},
          primaryConcerns: {},
          completionsByDay: {}
        };
        
        // Process data for basic analytics
        parsedData.forEach(item => {
          if (item.timestamp) {
            const date = item.timestamp.split('T')[0];
            analytics.completionsByDay[date] = (analytics.completionsByDay[date] || 0) + 1;
          }
          
          if (item.answers && item.answers.skin_type) {
            const skinType = item.answers.skin_type;
            analytics.skinTypes[skinType] = (analytics.skinTypes[skinType] || 0) + 1;
          }
          
          if (item.answers && item.answers.primary_concerns) {
            const concerns = Array.isArray(item.answers.primary_concerns) ? 
              item.answers.primary_concerns : [item.answers.primary_concerns];
            
            concerns.forEach(concern => {
              if (concern) {
                analytics.primaryConcerns[concern] = (analytics.primaryConcerns[concern] || 0) + 1;
              }
            });
          }
        });
        
        return analytics;
      } catch (storageError) {
        return Promise.reject(error);
      }
    } catch (error) {
      console.error("Error generating quiz analytics summary:", error);
      return Promise.reject(error);
    }
  };
  
  // Check if the DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOM loaded, Supabase quiz service is ready to use');
    });
  } else {
    console.log('DOM already loaded, Supabase quiz service is ready to use');
  }
})();

console.log('Supabase quiz service script loaded');
